export const DeliveryType = {
  TA: 'TA',
  EAT_IN: 'EAT_IN',
  DELIVERY: 'DELIVERY',
  MENU: 'MENU'
};
